import React from "react";
import SideBarChatService from "./DirectMessageSideBarChat";
import { useNavigate } from "react-router-dom";
function DirectMessageLeftSection(props) {
  const { messages } = props;
  const navigate = useNavigate();

  const handleChatSelection = (msgId) => {
    const params = new URLSearchParams(window.location.search);
    params.set("id", msgId);
    navigate({ search: params.toString() });
  };
  const messagesArray = Array.isArray(messages) ? messages : [];

  return (
    <>
      {messagesArray.length > 0 && (
        <div className="messaging-top-content">
          {messagesArray.map(
            (msg, index) => (
              msg.userId && (
                <SideBarChatService
                  key={msg.id}
                  msgData={msg}
                  userId={msg.userId}
                  onSelect={handleChatSelection}
                />
              )
            ),
          )}
        </div>
      )}
    </>
  );
}

export default DirectMessageLeftSection;
